export default "__VITE_ASSET__bKMstpw___"